import { render, staticRenderFns } from "./BrowseDefault.vue?vue&type=template&id=64700465"
import script from "./BrowseDefault.vue?vue&type=script&lang=ts"
export * from "./BrowseDefault.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64700465')) {
      api.createRecord('64700465', component.options)
    } else {
      api.reload('64700465', component.options)
    }
    module.hot.accept("./BrowseDefault.vue?vue&type=template&id=64700465", function () {
      api.rerender('64700465', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/BrowseDefault.vue"
export default component.exports